export default Object.freeze({
  Profession: 15,
});
